import { render, staticRenderFns } from "./BusinessType.vue?vue&type=template&id=f70d8a1e&"
import script from "./BusinessType.vue?vue&type=script&lang=ts&"
export * from "./BusinessType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports